import { RouterProvider } from 'react-router-dom';
import { createRoot, hydrateRoot } from 'react-dom/client';

import './index.css';
import * as serviceWorker from './serviceWorker';
import routes from './routes';

// ----------------------------------------------------------------------

const container = document.getElementById('root');
const root =
  container && container.hasChildNodes() ? hydrateRoot(container) : createRoot(container);

root.render(<RouterProvider router={routes} />);
// If you want to enable client cache, register instead.
serviceWorker.unregister();
